import { FavoriteMarketsContext } from '@/app/favorite-markets-provider';
import { useContext } from 'react';

export function useFavorites() {
  const context = useContext(FavoriteMarketsContext);
  return context;
}
